// === Exported Global Control Functions ===
/**
 * Opens the account settings modal if the component is in modal mode.
 * Dispatches a global event that the component listens to.
 */
export function openAccountSettingsModal() {
  document.dispatchEvent(
    new CustomEvent("open-user-profile", {
      bubbles: true,
      composed: true,
    }),
  );
}

/**
 * Closes the account settings modal if the component is in modal mode.
 * Dispatches a global event that the component listens to.
 */
export function closeAccountSettingsModal() {
  document.dispatchEvent(
    new CustomEvent("close-user-profile", {
      bubbles: true,
      composed: true,
    }),
  );
}
